import { Form } from '@/includes/types/Form.types'

export type FormsState = {
    forms: Array<Required<Form>> | null
}

export const formsState: FormsState = {
    forms: null
}
